<template>
	<div class="lamp" v-if="unit.name === 'smile-mini-04'">
		<h4 class="lamp__lead">
			Dla unitu {{ unit.fullName }} nie ma możliwości konfigurowania lampy.<br />Dostępna lampa dla
			tego modelu to Maszt z lampą LED-A z ramieniem pantograficznym
		</h4>
		<img class="lamp__image-no-config" :src="require('@/assets/pictures/lampa-2.jpg')" />
	</div>
	<div class="lamp" v-else>
		<div class="maincontent__double-header-wrapper">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Lampa zabiegowa</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small><br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>
		<div class="lamp__upper-section">
			<div>
				<h4 class="lamp__lead">Wybierz model lampy</h4>
				<small class="">Wybierz jedną opcję:</small>
				<div class="lamp__tiles">
					<div
						:class="{lamp__tile: true, 'lamp__tile--active': selectedLamp === lamp.name}"
						v-for="lamp in lamps"
						:key="lamp.fullName"
						@click="handleLampChange(lamp.name)"
					>
						<span class="lamp__cost">
							{{ formatPrice(lamp.cost) }}
						</span>
						<div class="lamp__radio">
							<span
								:class="['lamp__radio-checkmark', {'--checked': lamp.name === selectedLamp}]"
							></span>
							{{ lamp.fullName }}
						</div>
						<img class="lamp__image" :src="require(`@/assets/pictures/${lamp.image}`)" />
					</div>
				</div>
			</div>
			<div class="lamp__monitors-right-section" v-if="isLampOptionsSectionVisible">
				<h4 class="lamp__lead lamp__lead--with-bottom-margin">Opcje dodatkowe</h4>
				<Radio
					:checkbox="true"
					class="lamp__option-radio"
					v-for="lampOption in lampOptions"
					name="monitor-option"
					:value="lampOption.name"
					@change="handleLampOptionChange"
					:checked="selectedLampOptions.includes(lampOption.name)"
					:emitValueOnUncheck="true"
					:key="lampOption.name"
				>
					<span class="lamp__radio-label">
						{{ lampOption.fullName }}
					</span>
					<span class="lamp__radio-cost" slot="right-addon">
						{{ formatPrice(lampOption.cost) }}
					</span>
				</Radio>
			</div>
		</div>
		<HorizontalSeparator />
		<div class="lamp__monitors-section">
			<div>
				<h4 class="lamp__lead">Wybierz monitor</h4>
				<small>Wybierz jedną opcję:</small>
				<div class="lamp__tiles">
					<div
						v-for="monitor in monitors"
						:class="{lamp__tile: true, 'lamp__tile--active': selectedMonitor === monitor.name}"
						:key="monitor.fullName"
						@click="handleMonitorChange(monitor.name)"
					>
						<span class="lamp__cost">
							{{ formatPrice(monitor.cost) }}
						</span>
						<div class="lamp__radio lamp__radio--narrow">
							<span
								:class="['lamp__radio-checkmark', {'--checked': monitor.name === selectedMonitor}]"
							></span>
							{{ monitor.fullName }}
						</div>
						<img
							v-if="monitor.image"
							class="lamp__image"
							:src="require(`@/assets/pictures/${monitor.image}`)"
						/>
					</div>
				</div>
			</div>
			<div class="lamp__monitors-right-section" v-if="!isAppDataEmpty('monitorOptions')">
				<h4 class="lamp__lead lamp__lead--with-bottom-margin">Opcje dodatkowe</h4>
				<Radio
					:checkbox="true"
					class="lamp__option-radio"
					v-for="monitorOption in monitorOptions"
					name="monitor-option"
					:value="monitorOption.name"
					@change="handleMonitorOptionChange"
					:checked="
						!selectedMonitorOption ? false : selectedMonitorOption.name === monitorOption.name
					"
					:key="monitorOption.name"
				>
					<span class="lamp__radio-label">
						{{ monitorOption.fullName }}
					</span>
					<span class="lamp__radio-cost" slot="right-addon">
						{{ formatPrice(monitorOption.cost) }}
					</span>
				</Radio>
			</div>
		</div>
		<HorizontalSeparator />
		<div class="lamp__mast-section">
			<div class="lamp__mast-left-section">
				<h4 class="lamp__lead">Akcesoria masztu lampy</h4>
				<small class="lamp__description">Wybierz jedną opcję:</small>
				<Radio
					class="lamp__option-radio"
					v-for="lampMastAccessory in lampMastAccessories"
					name="lamp-mast"
					:value="lampMastAccessory.name"
					@change="handleLampMastAccessoryChange"
					:checked="lampMastAccessory.name === selectedLampMastAccessory"
					:key="lampMastAccessory.name"
				>
					<span class="lamp__radio-label">
						{{ lampMastAccessory.fullName }}
					</span>
					<span class="lamp__radio-cost" slot="right-addon">
						{{ formatPrice(lampMastAccessory.cost) }}
					</span>
				</Radio>
			</div>
			<div
				class="lamp__mast-right-section"
				v-if="!isAppDataEmpty('lampMastAccessoriesAdditionalOptions')"
			>
				<h4 class="lamp__lead lamp__lead--with-bottom-margin">Opcje dodatkowe</h4>
				<Radio
					:checkbox="true"
					class="lamp__option-radio"
					v-for="lampMastAccessoryAdditionalOption in lampMastAccessoriesAdditionalOptions"
					name="lamp-mast-accessory-additional-options"
					:value="lampMastAccessoryAdditionalOption.name"
					@change="handleLampMastAccessoryAdditionalOptionChange"
					:emitValueOnUncheck="true"
					:checked="
						selectedLampMastAccessoryAdditionalOptions.includes(
							lampMastAccessoryAdditionalOption.name
						)
					"
					:key="lampMastAccessoryAdditionalOption.name"
					:onmouseover="
						() =>
							setHighlightedLampMastAccessoryAdditionalOption(
								lampMastAccessoryAdditionalOption.name
							)
					"
					:onmouseleave="unsetHighlightedLampMastAccessoryAdditionalOption"
				>
					<span class="lamp__radio-label">
						{{ lampMastAccessoryAdditionalOption.fullName }}
					</span>
					<span class="lamp__radio-cost" slot="right-addon">
						{{ formatPrice(lampMastAccessoryAdditionalOption.cost) }}
					</span>
				</Radio>
				<img
					v-if="lampMastAccessoryAdditionalOptionImgSrc"
					class="lamp__mast-image"
					:src="require(`@/assets/pictures/${lampMastAccessoryAdditionalOptionImgSrc}`)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import Radio from '../Radio';
import HorizontalSeparator from '../HorizontalSeparator';

export default {
	name: 'Lamp',
	mixins: [AppDataMixin],
	components: {Radio, HorizontalSeparator},
	computed: {
		selectedLamp() {
			return this.$store.getters['unitConfiguration/data']('lamp').name;
		},
		selectedMonitor() {
			return this.$store.getters['unitConfiguration/data']('monitor').name;
		},
		selectedMonitorOption() {
			return this.$store.getters['unitConfiguration/data']('monitorOption');
		},
		selectedLampOptions() {
			return this.$store.getters['unitConfiguration/data']('lampOptions').map(
				option => option.name
			);
		},
		selectedLampMastAccessory() {
			return this.$store.getters['unitConfiguration/data']('lampMastAccessory').name;
		},
		selectedLampMastAccessoryAdditionalOptions() {
			return this.$store.getters['unitConfiguration/data'](
				'lampMastAccessoriesAdditionalOptions'
			).map(option => option.name);
		},
		isLampOptionsSectionVisible() {
			if (this.isAppDataEmpty('lampOptions')) {
				return false;
			}
			return ['lamp-02', 'lamp-03'].includes(this.selectedLamp);
		},
		lampMastAccessoryAdditionalOptionImgSrc() {
			const selectedOption = R.pipe(
				R.values,
				R.find(option => option.name === this.highlightedLampMastAccessoryAdditionalOption)
			)(this.lampMastAccessoriesAdditionalOptions);
			return R.propOr(null, 'image', selectedOption);
		},
		isLampMastColorOptionVisible() {
			if (this.unit.name === 'chirana-effective') {
				return ['lamp-02', 'lamp-03'].includes(this.selectedLamp);
			}
			if (this.unit.name === 'chirana-l') {
				return ['lamp-01', 'lamp-02'].includes(this.selectedLamp);
			}
			return false;
		},
	},
	data() {
		return {
			lamps: [],
			lampOptions: [],
			monitors: [],
			monitorOptions: [],
			lampMastAccessories: [],
			lampMastAccessoriesAdditionalOptions: {},
			highlightedLampMastAccessoryAdditionalOption: null,
		};
	},
	mounted() {
		this.lamps = this.getAppData('lamps');
		this.lampOptions = this.getAppData('lampOptions');
		this.monitors = this.getAppData('monitors');
		this.monitorOptions = this.getAppData('monitorOptions');
		this.lampMastAccessories = this.getAppData('lampMastAccessories');
		this.setLampMastAccessoriesAdditionalOptions();
	},
	methods: {
		setLampMastAccessoriesAdditionalOptions() {
			this.lampMastAccessoriesAdditionalOptions = R.pickBy(
				(_, opt) => opt !== 'lamp-mast-color' || this.isLampMastColorOptionVisible,
				this.getAppData('lampMastAccessoriesAdditionalOptions')
			);
		},
		handleLampChange(value) {
			this.$store.commit('unitConfiguration/setLamp', value);
			if (!this.isLampOptionsSectionVisible) {
				this.$store.commit('unitConfiguration/setLampOptions', []);
			}
			this.setLampMastAccessoriesAdditionalOptions();
		},
		handleLampOptionChange(lampOption) {
			const newLampOptions = this.selectedLampOptions.includes(lampOption)
				? R.without([lampOption], this.selectedLampOptions)
				: R.pipe(R.append(lampOption))(this.selectedLampOptions);

			this.$store.commit('unitConfiguration/setLampOptions', newLampOptions);
		},
		handleMonitorChange(value) {
			this.$store.commit('unitConfiguration/setMonitor', value);
		},
		handleMonitorOptionChange(newMonitorOption) {
			this.$store.commit(
				'unitConfiguration/setMonitorOption',
				this.selectedMonitorOption ? null : newMonitorOption
			);
		},
		handleLampMastAccessoryChange(newLampMastAccessory) {
			this.$store.commit('unitConfiguration/setLampMastAccessory', newLampMastAccessory);
		},
		handleLampMastAccessoryAdditionalOptionChange(newLampMastAccessoryAdditionalOption) {
			this.$store.commit(
				'unitConfiguration/setLampMastAccessoriesAdditionalOption',
				newLampMastAccessoryAdditionalOption
			);
		},
		setHighlightedLampMastAccessoryAdditionalOption(optionName) {
			this.highlightedLampMastAccessoryAdditionalOption = optionName;
		},
		unsetHighlightedLampMastAccessoryAdditionalOption() {
			this.highlightedLampMastAccessoryAdditionalOption = null;
		},
	},
};
</script>
